import { render, staticRenderFns } from "./BotOrder.vue?vue&type=template&id=9ca52834&scoped=true"
import script from "./BotOrder.vue?vue&type=script&lang=js"
export * from "./BotOrder.vue?vue&type=script&lang=js"
import style0 from "./BotOrder.vue?vue&type=style&index=0&id=9ca52834&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca52834",
  null
  
)

export default component.exports